import { ToastrService } from 'ngx-toastr';
import { AuthService } from './../../../@resources/services/auth.service';
import { AuthDialogComponent } from '../auth-dialog/auth-dialog.component';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from '../reset-password-dialog/reset-password-dialog.component';

@Component({
	selector: 'app-forget-password-dialog',
	templateUrl: './forget-password-dialog.component.html',
	styleUrls: ['./forget-password-dialog.component.scss']
})
export class ForgetPasswordDialogComponent implements OnInit {
	isSubmitting:boolean;
	email: FormControl = new FormControl('', [Validators.required, Validators.email]);
	constructor(public dialogRef: MatDialogRef<ForgetPasswordDialogComponent>, public dialog: MatDialog,
				private authService: AuthService, private toastrService:ToastrService) { }

	ngOnInit(): void {
	}

	forgetPassword() {
		this.isSubmitting = true;
		this.authService.forgetPassword({ email: this.email.value }).subscribe((res:any) =>{
			if(res?.data?.forgetPassword){
				this.isSubmitting = false;
				this.toastrService.success(`${res?.data?.forgetPassword?.message}`,`Verification`)
				this.dialogRef.close();
				const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
				});
			}
		},(error) =>{
			this.isSubmitting = false;
		})
		
		
	}

	navigateToLogin() {
		this.dialogRef.close();
		const dialogRef = this.dialog.open(AuthDialogComponent, {
		});
	}

}
